import axios from '../base/axios';
import API_KEY from './key';

const GET_DRAMA = 'flixfrenzy/redux/GET_DRAMA';

// eslint-disable-next-line default-param-last
const dramaReducer = (state = [], action) => {
  switch (action.type) {
    case GET_DRAMA:
      return action.payload;
    default:
      return state;
  }
};

export const getDrama = () => (dispatch) => {
  axios.get(`discover/movie?api_key=${API_KEY}&with_genres=10749`).then((res) => {
    dispatch({
      type: GET_DRAMA,
      payload: res.data,
    });
  });
};

export default dramaReducer;
